var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrototyping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1119,
    height: 871,
    viewBox: "0 0 1119 871",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M923.138 462.589L923.048 472.156L1069.28 473.535L1069.37 463.968L923.138 462.589Z",
    fill: "#C0E7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.37 463.965L1069.28 473.532L1091.86 473.745L1091.95 464.178L1069.37 463.965Z",
    fill: "#C0E7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.87 511.073L1075.19 510.927L1075.28 501.36L1090.96 501.506C1094.77 501.543 1097.91 498.463 1097.94 494.647L1098.07 480.686C1098.11 476.869 1095.03 473.732 1091.22 473.698L1091.3 464.131C1100.4 464.217 1107.72 471.684 1107.64 480.777L1107.51 494.738C1107.42 503.831 1099.96 511.162 1090.86 511.076L1090.87 511.073Z",
    fill: "#C0E7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.63 548.396L1068.95 548.25C1059.86 548.165 1052.53 540.697 1052.61 531.604L1052.75 517.643C1052.83 508.55 1060.3 501.22 1069.39 501.305L1083.89 501.443L1083.8 511.01L1069.3 510.873C1065.48 510.836 1062.35 513.915 1062.31 517.732L1062.18 531.693C1062.14 535.509 1065.22 538.646 1069.04 538.68L1084.72 538.826L1084.63 548.393L1084.63 548.396Z",
    fill: "#C0E7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.38 576.087L1066.29 585.654L1088.87 585.867L1088.96 576.3L1066.38 576.087Z",
    fill: "#C0E7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.43 739.256L1048.87 739.167L1050.24 592.381C1050.33 583.288 1057.79 575.958 1066.88 576.044L1066.79 585.611C1062.98 585.574 1059.84 588.653 1059.81 592.47L1058.43 739.256H1058.43Z",
    fill: "#C0E7FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.18 585.812L1088.27 576.244C1092.09 576.279 1095.22 573.202 1095.26 569.385L1095.39 555.421C1095.42 551.605 1092.35 548.468 1088.53 548.434L1073.77 548.297L1073.86 538.729L1088.62 538.867C1097.71 538.952 1105.04 546.42 1104.95 555.513L1104.82 569.477C1104.74 578.57 1097.27 585.9 1088.18 585.814L1088.18 585.812Z",
    fill: "#C0E7FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.72 613.068H1056.64L1052.67 613.094H1052.63C1052.59 614.025 1052.39 614.962 1052.39 615.885V615.908L1056.49 615.448H1056.49C1056.52 615.051 1056.55 614.682 1056.57 614.259C1056.6 613.834 1056.69 613.46 1056.71 613.062L1056.72 613.068Z",
    fill: "#CECECE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.18 630.315L1048.46 630.417C1048.3 630.418 1048.16 630.288 1048.16 630.125L1048.04 615.108C1048.04 614.945 1048.17 614.812 1048.33 614.811L1061.06 614.709C1061.22 614.708 1061.35 614.838 1061.35 615.001L1061.48 630.018C1061.48 630.181 1061.35 630.314 1061.18 630.315Z",
    fill: "#C0E7FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.4 628.885L1062.98 628.751C1064.75 628.737 1066.21 630.174 1066.22 631.945L1066.45 661.004C1066.47 662.775 1065.03 664.235 1063.26 664.249L1046.68 664.383C1044.91 664.398 1043.45 662.961 1043.44 661.19L1043.2 632.131C1043.19 630.359 1044.62 628.9 1046.4 628.885Z",
    fill: "#C0E7FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.39 628.274L1062.97 628.14C1065.09 628.123 1066.82 629.828 1066.84 631.942L1067.07 661.001C1067.08 662.021 1066.69 662.989 1065.97 663.718C1065.25 664.449 1064.29 664.858 1063.27 664.866L1046.69 665C1045.67 665.009 1044.7 664.618 1043.97 663.898C1043.24 663.178 1042.83 662.218 1042.83 661.198L1042.59 632.139C1042.58 631.197 1042.92 630.328 1043.48 629.654C1044.18 628.82 1045.22 628.283 1046.39 628.274ZM1065.85 661.012L1065.61 631.953C1065.6 630.517 1064.42 629.357 1062.98 629.368L1046.4 629.502C1044.97 629.514 1043.81 630.694 1043.82 632.131L1044.05 661.19C1044.06 661.884 1044.33 662.535 1044.83 663.024C1045.33 663.515 1045.99 663.781 1046.68 663.775L1063.26 663.641C1063.96 663.635 1064.61 663.358 1065.1 662.858C1065.15 662.806 1065.2 662.752 1065.25 662.695C1065.64 662.221 1065.86 661.629 1065.85 661.01L1065.85 661.012Z",
    fill: "#E0E0E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.04 636.507L1052.72 636.542L1052.85 652.219L1057.16 652.185L1057.04 636.507Z",
    fill: "#E0E0E0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.79 668.666H1031.5C1013.27 668.666 998.489 683.449 998.489 701.684V836.992C998.489 855.227 1013.27 870.01 1031.5 870.01H1073.79C1092.02 870.01 1106.8 855.227 1106.8 836.992V701.684C1106.8 683.449 1092.02 668.666 1073.79 668.666Z",
    fill: "#575757"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.54 664.627H1032.75C1013.83 664.627 998.489 679.97 998.489 698.897V831.701C998.489 850.628 1013.83 865.971 1032.75 865.971H1072.54C1091.46 865.971 1106.8 850.628 1106.8 831.701V698.897C1106.8 679.97 1091.46 664.627 1072.54 664.627Z",
    fill: "#0086FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.61 852.696C1017.68 846.694 1007.46 826.151 1007.46 810.11V740.297C1007.46 733.815 1012.72 728.562 1019.2 728.562H1031.55C1050.32 728.562 1065.54 743.782 1065.54 762.557V839.332C1065.54 869.119 1031.61 852.696 1031.61 852.696Z",
    fill: "#C0E7FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M678.127 728.421H466.596V806.644H678.127V728.421Z",
    fill: "#6293FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M678.127 736.631H466.596V745.038H678.127V736.631Z",
    fill: "#362A99"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M702.439 801.665H572.359H442.281L414.322 829.724H572.359H730.399L702.439 801.665Z",
    fill: "#C0E7FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M198.489 190.628H946.231C956.291 190.628 964.46 198.798 964.46 208.86V718.399C964.46 728.46 956.291 736.63 946.231 736.63H198.489C188.43 736.63 180.261 728.46 180.261 718.399V208.86C180.261 198.798 188.43 190.628 198.489 190.628Z",
    fill: "#407BFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M964.46 667.029H180.261V208.82C180.261 198.775 188.404 190.631 198.446 190.631H946.151C956.262 190.631 964.46 198.83 964.46 208.943V667.029Z",
    fill: "#575757"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M918.446 223.115H226.271C222.325 223.115 219.125 226.315 219.125 230.263V624.043C219.125 627.991 222.325 631.191 226.271 631.191H918.446C922.393 631.191 925.592 627.991 925.592 624.043V230.263C925.592 226.315 922.393 223.115 918.446 223.115Z",
    fill: "#B4B4B4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M581.462 700.49C581.462 705.518 577.386 709.595 572.359 709.595C567.332 709.595 563.256 705.518 563.256 700.49C563.256 695.462 567.332 691.386 572.359 691.386C577.386 691.386 581.462 695.462 581.462 700.49Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M642.145 700.49C642.145 707.667 636.327 713.486 629.152 713.486C621.977 713.486 616.159 707.667 616.159 700.49C616.159 693.314 621.977 687.495 629.152 687.495C636.327 687.495 642.145 693.314 642.145 700.49Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M698.938 700.49C698.938 707.667 693.119 713.486 685.945 713.486C678.77 713.486 672.952 707.667 672.952 700.49C672.952 693.314 678.77 687.495 685.945 687.495C693.119 687.495 698.938 693.314 698.938 700.49Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M471.766 700.49C471.766 707.667 465.948 713.486 458.773 713.486C451.598 713.486 445.78 707.667 445.78 700.49C445.78 693.314 451.598 687.495 458.773 687.495C465.948 687.495 471.766 693.314 471.766 700.49Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M528.559 700.49C528.559 707.667 522.741 713.486 515.566 713.486C508.391 713.486 502.573 707.667 502.573 700.49C502.573 693.314 508.391 687.495 515.566 687.495C522.741 687.495 528.559 693.314 528.559 700.49Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M505.749 223.115L219.125 522.057V349.178L339.792 223.115H505.749Z",
    fill: "#DCE7F4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M587.068 223.016L219.125 606.843V546.16L528.89 223.116L587.068 223.016Z",
    fill: "#DCE7F4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M968.361 665.592H184.045V667.306H968.361V665.592Z",
    fill: "#C7CACE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M897.927 147.945C897.927 104.111 947.231 68.5732 1008.05 68.5732C1068.88 68.5732 1118.18 104.108 1118.18 147.945C1118.18 191.782 1068.88 227.317 1008.05 227.317C994.301 227.317 981.143 225.495 969.004 222.178L948.822 247.257L937.103 208.648C913.148 194.088 897.927 172.302 897.927 147.951V147.945Z",
    fill: "#0086FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M984.085 125.705H1005.71C1005.83 125.705 1005.93 125.608 1005.93 125.488V119.7C1005.93 119.58 1005.83 119.483 1005.71 119.483H984.085C983.965 119.483 983.868 119.58 983.868 119.7V125.488C983.868 125.608 983.965 125.705 984.085 125.705Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.8 125.705H1035.42C1035.54 125.705 1035.64 125.608 1035.64 125.488V119.7C1035.64 119.58 1035.54 119.483 1035.42 119.483H1013.8C1013.68 119.483 1013.58 119.58 1013.58 119.7V125.488C1013.58 125.608 1013.68 125.705 1013.8 125.705Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M994.653 163.429H1016.28C1016.4 163.429 1016.5 163.332 1016.5 163.212V157.424C1016.5 157.304 1016.4 157.207 1016.28 157.207H994.653C994.533 157.207 994.436 157.304 994.436 157.424V163.212C994.436 163.332 994.533 163.429 994.653 163.429Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M943.903 163.429H987.244C987.446 163.429 987.609 163.265 987.609 163.063V157.572C987.609 157.37 987.446 157.207 987.244 157.207H943.903C943.702 157.207 943.538 157.37 943.538 157.572V163.063C943.538 163.265 943.702 163.429 943.903 163.429Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M943.309 125.705H975.442C975.587 125.705 975.705 125.587 975.705 125.442V119.746C975.705 119.601 975.587 119.483 975.442 119.483H943.309C943.164 119.483 943.047 119.601 943.047 119.746V125.442C943.047 125.587 943.164 125.705 943.309 125.705Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M944.857 144.223H1023.32C1023.51 144.223 1023.66 144.072 1023.66 143.886V138.338C1023.66 138.152 1023.51 138.001 1023.32 138.001H944.857C944.671 138.001 944.52 138.152 944.52 138.338V143.886C944.52 144.072 944.671 144.223 944.857 144.223Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.75 181.172H960.424C960.238 181.172 960.087 181.02 960.087 180.835V175.29C960.087 175.104 960.238 174.953 960.424 174.953H1025.75C1025.93 174.953 1026.08 175.104 1026.08 175.29V180.835C1026.08 181.02 1025.93 181.172 1025.75 181.172Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M563.847 95.3359H360.145V156.079H563.847V95.3359Z",
    fill: "#415F85"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M491.517 123.809H394.305V127.605H491.517V123.809Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M563.847 95.3359H507.123V156.079H563.847V95.3359Z",
    fill: "#0086FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M389.358 125.706L379.864 131.191V120.224L389.358 125.706Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M541.286 119.906H529.687V131.508H541.286V119.906Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M416.121 326.381H50.5602V559.12H416.121V326.381Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M405.256 359.239H185.576V546.648H405.256V359.239Z",
    fill: "#C0E7FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M181.775 359.239H62.8134V546.648H181.775V359.239Z",
    fill: "#C0E7FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M120.535 338.854H108.279V351.112H120.535V338.854Z",
    fill: "#C0E7FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M395.419 370.501H363.21V382.759H395.419V370.501Z",
    fill: "#0086FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M102.341 338.854H63.2418V351.112H102.341V338.854Z",
    fill: "#C0E7FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M395.419 382.759H198.878V471.855H395.419V382.759Z",
    fill: "#2D3C59"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M395.419 484.588H363.21V496.846H395.419V484.588Z",
    fill: "#0086FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M395.419 496.849H198.878V533.341H395.419V496.849Z",
    fill: "#2D3C59"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M387.973 504.119H353.696V508.539H387.973V504.119Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M335.819 504.119H312.612V508.539H335.819V504.119Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M292.921 504.119H250.946V508.539H292.921V504.119Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M237.431 504.119H217.691V508.539H237.431V504.119Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M331.571 452.587H212.182V466.722H331.571V452.587Z",
    fill: "#C0E7FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M390.898 515.369H207.275V529.504H390.898V515.369Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M173.84 370.501H141.63V382.759H173.84V370.501Z",
    fill: "#0086FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M173.84 382.759H72.0303V484.588H173.84V382.759Z",
    fill: "#2D3C59"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M173.84 494.853H141.63V507.111H173.84V494.853Z",
    fill: "#0086FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M173.84 507.113H72.0303V533.344H173.84V507.113Z",
    fill: "#2D3C59"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4777 389.887H78.2769V396.089H84.4777V389.887Z",
    fill: "#0086FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M139.931 393.912H92.9492C92.5208 393.912 92.1752 393.809 92.1752 393.68V392.292C92.1752 392.163 92.5208 392.061 92.9492 392.061H139.931C140.359 392.061 140.705 392.163 140.705 392.292V393.68C140.705 393.809 140.359 393.912 139.931 393.912Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M160.898 404.675H93.2891C92.675 404.675 92.1752 404.573 92.1752 404.444V403.056C92.1752 402.927 92.675 402.824 93.2891 402.824H160.898C161.513 402.824 162.012 402.927 162.012 403.056V404.444C162.012 404.573 161.513 404.675 160.898 404.675Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M127.646 415.437H92.7493C92.4322 415.437 92.1752 415.334 92.1752 415.206V413.817C92.1752 413.689 92.4322 413.586 92.7493 413.586H127.646C127.964 413.586 128.221 413.689 128.221 413.817V415.206C128.221 415.334 127.964 415.437 127.646 415.437Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M148.508 426.202H93.0864C92.5837 426.202 92.1724 426.099 92.1724 425.97V424.582C92.1724 424.453 92.5808 424.351 93.0864 424.351H148.508C149.011 424.351 149.422 424.453 149.422 424.582V425.97C149.422 426.099 149.014 426.202 148.508 426.202Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M119.898 436.962H92.6236C92.3751 436.962 92.1752 436.86 92.1752 436.731V435.343C92.1752 435.214 92.3751 435.111 92.6236 435.111H119.898C120.146 435.111 120.346 435.214 120.346 435.343V436.731C120.346 436.86 120.146 436.962 119.898 436.962Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M125.907 451.218H100.013C99.7784 451.218 99.587 451.115 99.587 450.987V449.599C99.587 449.47 99.7784 449.367 100.013 449.367H125.907C126.141 449.367 126.333 449.47 126.333 449.599V450.987C126.333 451.115 126.141 451.218 125.907 451.218Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M156.109 464.334H100.501C99.9955 464.334 99.5842 464.231 99.5842 464.102V462.714C99.5842 462.585 99.9955 462.482 100.501 462.482H156.109C156.614 462.482 157.026 462.585 157.026 462.714V464.102C157.026 464.231 156.614 464.334 156.109 464.334Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M144.047 478.115H100.307C99.9098 478.115 99.587 478.012 99.587 477.883V476.495C99.587 476.367 99.9098 476.264 100.307 476.264H144.047C144.444 476.264 144.767 476.367 144.767 476.495V477.883C144.767 478.012 144.444 478.115 144.047 478.115Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4777 400.65H78.2769V406.852H84.4777V400.65Z",
    fill: "#0086FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4777 411.412H78.2769V417.614H84.4777V411.412Z",
    fill: "#0086FF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4777 422.177H78.2769V428.379H84.4777V422.177Z",
    fill: "#0086FF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4777 432.938H78.2769V439.139H84.4777V432.938Z",
    fill: "#0086FF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8896 447.193H85.6887V453.395H91.8896V447.193Z",
    fill: "#0086FF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8896 460.309H85.6887V466.511H91.8896V460.309Z",
    fill: "#0086FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8896 474.086H85.6887V480.288H91.8896V474.086Z",
    fill: "#0086FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4777 518.446H78.2769V524.648H84.4777V518.446Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M136.581 518.446H92.9492C92.5217 518.446 92.1752 518.793 92.1752 519.22V523.874C92.1752 524.302 92.5217 524.648 92.9492 524.648H136.581C137.008 524.648 137.355 524.302 137.355 523.874V519.22C137.355 518.793 137.008 518.446 136.581 518.446Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M389.718 390.601H363.21V395.02H389.718V390.601Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M374.683 401.576H358.434V405.996H374.683V401.576Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M352.45 401.576H337.841V405.996H352.45V401.576Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M331.069 401.576H305.843V405.996H331.069V401.576Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M358.437 411.697H332.426V416.117H358.437V411.697Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M375.537 429.658H366.132V434.078H375.537V429.658Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M360.145 429.658H336.653V434.078H360.145V429.658Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M358.626 439.257H341.545V443.676H358.626V439.257Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M389.413 457.743H378.936V462.163H389.413V457.743Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M372.829 457.743H338.552V462.163H372.829V457.743Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M335.822 439.257H303.823V443.676H335.822V439.257Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M298.588 439.257H278.123V443.676H298.588V439.257Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M272.682 439.257H260.306V443.676H272.682V439.257Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M311.544 411.697H291.233V416.117H311.544V411.697Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M284.133 411.697H249.807V416.117H284.133V411.697Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M326.296 411.697H317.388V416.117H326.296V411.697Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M359.648 390.601H331.072V395.02H359.648V390.601Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M326.796 390.601H284.892V395.02H326.796V390.601Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M326.225 457.743H303.421V462.163H326.225V457.743Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M298.588 457.743H290.713V462.163H298.588V457.743Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M285.998 457.743H257.124V462.163H285.998V457.743Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M252.409 457.743H236.031V462.163H252.409V457.743Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M232.741 457.743H218.5V462.163H232.741V457.743Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M387.973 520.226H364.492V524.645H387.973V520.226Z",
    fill: "#C0E7FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M354.335 520.226H338.552V524.645H354.335V520.226Z",
    fill: "#C0E7FF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M326.225 520.226H302.778V524.645H326.225V520.226Z",
    fill: "#C0E7FF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M289.311 520.226H224.96V524.645H289.311V520.226Z",
    fill: "#C0E7FF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M870.464 3.4082H605.334V362.442H870.464V3.4082Z",
    fill: "#FEFEFF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M870.465 3.4082H605.368V30.5445H870.465V3.4082Z",
    fill: "#0086FF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M870.465 30.5449H605.368V186.281H870.465V30.5449Z",
    fill: "#C0E7FF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M688.678 201.627H626.427V263.89H688.678V201.627Z",
    fill: "#E5E5E5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M688.678 201.627V263.89H626.427V201.627H688.678ZM689.941 200.364H625.162V265.155H689.941V200.364Z",
    fill: "#A1A9B2"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M688.678 261.507V263.893H686.47L658.271 235.614L655.643 233.2L626.427 204.187V201.627H629.143L658.119 230.772L688.678 261.507Z",
    fill: "#FEFEFF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M688.678 201.627V204.818L660.493 233.163L658.197 235.614L630.066 263.893H626.427V262.136L655.643 233.163L658.148 230.772L687.393 201.627H688.678Z",
    fill: "#FEFEFF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M659.556 269.749H627.895V275.483H659.556V269.749Z",
    fill: "#415065"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M679.684 281.587H627.895V284.732H679.684V281.587Z",
    fill: "#A1A9B2"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M679.684 288.612H627.895V291.758H679.684V288.612Z",
    fill: "#A1A9B2"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M679.684 295.64H627.895V298.785H679.684V295.64Z",
    fill: "#A1A9B2"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M769.149 201.627H706.898V263.89H769.149V201.627Z",
    fill: "#E5E5E5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M769.149 201.627V263.89H706.898V201.627H769.149ZM770.411 200.364H705.633V265.155H770.411V200.364Z",
    fill: "#A1A9B2"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M769.149 261.507V263.893H766.984L738.787 235.614L736.137 233.2L706.898 204.187V201.627H709.66L738.613 230.772L769.149 261.507Z",
    fill: "#FEFEFF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M769.149 201.627V204.818L740.987 233.163L738.699 235.614L710.582 263.893H706.898V262.136L736.137 233.163L738.653 230.772L767.906 201.627H769.149Z",
    fill: "#FEFEFF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M740.073 269.749H708.412V275.483H740.073V269.749Z",
    fill: "#415065"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M760.2 281.587H708.412V284.732H760.2V281.587Z",
    fill: "#A1A9B2"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M760.2 288.612H708.412V291.758H760.2V288.612Z",
    fill: "#A1A9B2"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M760.2 295.64H708.412V298.785H760.2V295.64Z",
    fill: "#A1A9B2"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M849.62 201.627H787.369V263.89H849.62V201.627Z",
    fill: "#E5E5E5"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M849.623 201.627V263.89H787.372V201.627H849.623ZM850.885 200.364H786.106V265.155H850.885V200.364Z",
    fill: "#A1A9B2"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M849.623 261.507V263.893H847.5L819.304 235.614L816.631 233.2L787.369 204.187V201.627H790.173L819.107 230.772L849.623 261.507Z",
    fill: "#FEFEFF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M849.623 201.627V204.818L821.48 233.163L819.204 235.614L791.096 263.893H787.369V262.136L816.631 233.163L819.158 230.772L848.423 201.627H849.623Z",
    fill: "#FEFEFF"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M820.586 269.749H788.925V275.483H820.586V269.749Z",
    fill: "#415065"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M840.714 281.587H788.925V284.732H840.714V281.587Z",
    fill: "#A1A9B2"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M840.714 288.612H788.925V291.758H840.714V288.612Z",
    fill: "#A1A9B2"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M840.714 295.64H788.925V298.785H840.714V295.64Z",
    fill: "#A1A9B2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M679.684 302.664H627.895V305.809H679.684V302.664Z",
    fill: "#A1A9B2"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M679.684 309.689H627.895V312.835H679.684V309.689Z",
    fill: "#A1A9B2"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M679.684 316.714H627.895V319.859H679.684V316.714Z",
    fill: "#A1A9B2"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M760.2 302.664H708.412V305.809H760.2V302.664Z",
    fill: "#A1A9B2"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M760.2 309.689H708.412V312.835H760.2V309.689Z",
    fill: "#A1A9B2"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M760.2 316.714H708.412V319.859H760.2V316.714Z",
    fill: "#A1A9B2"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M840.714 302.664H788.925V305.809H840.714V302.664Z",
    fill: "#A1A9B2"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M840.714 309.689H788.925V312.835H840.714V309.689Z",
    fill: "#A1A9B2"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M840.714 316.714H788.925V319.859H840.714V316.714Z",
    fill: "#A1A9B2"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M870.756 321.819H605.334V362.442H870.756V321.819Z",
    fill: "#407BFF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M620.72 23.3857C624.258 23.3857 627.127 20.5169 627.127 16.978C627.127 13.4391 624.258 10.5703 620.72 10.5703C617.182 10.5703 614.314 13.4391 614.314 16.978C614.314 20.5169 617.182 23.3857 620.72 23.3857Z",
    fill: "#415065"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M641.085 23.3857C644.623 23.3857 647.491 20.5169 647.491 16.978C647.491 13.4391 644.623 10.5703 641.085 10.5703C637.547 10.5703 634.678 13.4391 634.678 16.978C634.678 20.5169 637.547 23.3857 641.085 23.3857Z",
    fill: "#415065"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M661.453 23.3857C664.991 23.3857 667.859 20.5169 667.859 16.978C667.859 13.4391 664.991 10.5703 661.453 10.5703C657.914 10.5703 655.046 13.4391 655.046 16.978C655.046 20.5169 657.914 23.3857 661.453 23.3857Z",
    fill: "#415065"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M679.684 323.741H627.895V326.886H679.684V323.741Z",
    fill: "#FEFEFF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M679.684 330.767H627.895V333.912H679.684V330.767Z",
    fill: "#FEFEFF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M679.684 337.791H627.895V340.936H679.684V337.791Z",
    fill: "#FEFEFF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M760.2 323.741H708.412V326.886H760.2V323.741Z",
    fill: "#FEFEFF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M760.2 330.767H708.412V333.912H760.2V330.767Z",
    fill: "#FEFEFF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M760.2 337.791H708.412V340.936H760.2V337.791Z",
    fill: "#FEFEFF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M840.714 323.741H788.925V326.886H840.714V323.741Z",
    fill: "#FEFEFF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M840.714 330.767H788.925V333.912H840.714V330.767Z",
    fill: "#FEFEFF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M840.714 337.791H788.925V340.936H840.714V337.791Z",
    fill: "#FEFEFF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M737.899 164.46C768.847 164.46 793.935 139.368 793.935 108.414C793.935 77.4601 768.847 52.3672 737.899 52.3672C706.951 52.3672 681.863 77.4601 681.863 108.414C681.863 139.368 706.951 164.46 737.899 164.46Z",
    fill: "#FEFEFF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M753.558 107.998C762.058 99.4959 762.058 85.7111 753.558 77.2089C745.057 68.7067 731.275 68.7067 722.774 77.2089C714.273 85.7111 714.273 99.4959 722.774 107.998C731.275 116.5 745.057 116.5 753.558 107.998Z",
    fill: "#407BFF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M763.699 139.446C763.699 139.446 762.017 146.411 741.504 147.768C740.767 147.817 739.987 147.86 739.199 147.891C738.81 147.908 738.419 147.922 737.996 147.937C737.574 147.925 737.402 147.917 737.117 147.905C736.214 147.868 735.343 147.822 734.503 147.765C714.004 146.403 712.319 139.444 712.319 139.444C710.677 120.423 725.412 114.747 725.412 114.747C727.226 115.693 728.885 116.41 730.362 116.95C731.056 117.204 731.707 117.418 732.315 117.598C732.481 117.647 732.644 117.695 732.804 117.738C732.804 117.738 732.807 117.738 732.809 117.738C733.172 117.838 733.523 117.927 733.849 118.007C736.24 118.581 737.574 118.598 737.996 118.592C738.419 118.598 739.853 118.581 742.372 117.955C742.635 117.889 742.915 117.818 743.197 117.738C743.426 117.672 743.666 117.607 743.909 117.529C744.457 117.364 745.04 117.17 745.654 116.947C747.13 116.41 748.79 115.693 750.604 114.744C750.604 114.744 765.342 120.421 763.699 139.441V139.446Z",
    fill: "#407BFF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M743.486 140.838L738.156 146.72L732.846 140.838L736.462 123.586C734.8 122.923 733.623 121.3 733.623 119.404C733.623 118.918 733.706 118.449 733.849 118.012C736.24 118.587 737.573 118.604 737.996 118.598C738.102 118.604 739.853 118.587 742.372 117.961C742.526 118.415 742.618 118.901 742.618 119.406C742.618 121.269 741.492 122.869 739.878 123.554L743.489 140.841L743.486 140.838Z",
    fill: "#FEFEFF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M745.037 140.515L741.666 124.354C743.243 123.229 744.209 121.397 744.209 119.403C744.209 118.752 744.106 118.124 743.914 117.535C743.672 117.609 743.437 117.678 743.209 117.744C742.926 117.824 742.655 117.895 742.392 117.961C742.546 118.415 742.629 118.901 742.629 119.406C742.629 121.269 741.498 122.869 739.884 123.554L743.489 140.841L738.159 146.723L732.849 140.841L736.465 123.589C734.803 122.926 733.626 121.303 733.626 119.406C733.626 118.921 733.703 118.452 733.846 118.015C733.518 117.935 733.175 117.847 732.812 117.747C732.812 117.747 732.809 117.747 732.806 117.747C732.647 117.701 732.484 117.655 732.318 117.607C732.141 118.178 732.047 118.784 732.047 119.412C732.047 120.655 732.418 121.849 733.124 122.869C733.546 123.483 734.075 124.006 734.677 124.423L731.301 140.523C731.198 141.018 731.336 141.535 731.675 141.909L736.985 147.791C737.025 147.837 737.074 147.877 737.119 147.917C737.408 147.928 737.579 147.94 737.999 147.948C738.422 147.934 738.813 147.92 739.202 147.902C739.242 147.868 739.287 147.831 739.322 147.794L744.66 141.912C745 141.538 745.142 141.023 745.04 140.526L745.037 140.515Z",
    fill: "#407BFF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M738.108 70.7109V114.251C749.99 114.196 759.772 104.469 759.772 92.4823C759.772 80.4953 749.99 70.7652 738.108 70.7109Z",
    fill: "#020202"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M737.996 118.496V147.834C738.419 147.826 738.619 147.817 738.899 147.803C739.801 147.766 740.695 147.72 741.532 147.666C762.031 146.303 763.728 139.344 763.728 139.344C765.37 120.324 750.641 114.647 750.641 114.647C748.824 115.593 747.17 116.31 745.694 116.85C745 117.101 744.351 117.316 743.743 117.499C743.577 117.55 743.415 117.596 743.255 117.641C743.252 117.641 743.252 117.641 743.249 117.641C742.886 117.741 742.492 117.83 742.166 117.91C739.824 118.476 738.419 118.498 737.999 118.496H737.996Z",
    fill: "#020202"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M724.109 493.521H481.945V573.579H724.109V493.521Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M558.479 539.786C561.732 526 553.195 512.186 539.412 508.932C525.628 505.678 511.817 514.217 508.564 528.003C505.311 541.789 513.847 555.603 527.631 558.856C541.415 562.11 555.226 553.572 558.479 539.786Z",
    fill: "#0086FF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M528.027 527.117C528.027 529.148 526.382 530.794 524.351 530.794C522.321 530.794 520.676 529.148 520.676 527.117C520.676 525.086 522.321 523.44 524.351 523.44C526.382 523.44 528.027 525.086 528.027 527.117Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M546.401 527.117C546.401 529.148 544.756 530.794 542.726 530.794C540.695 530.794 539.05 529.148 539.05 527.117C539.05 525.086 540.695 523.44 542.726 523.44C544.756 523.44 546.401 525.086 546.401 527.117Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M547.258 536.31C547.258 543.889 541.115 550.03 533.54 550.03C525.965 550.03 519.822 543.886 519.822 536.31H547.261H547.258Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M724.241 493.599V500.418L724.112 500.615L651.053 573.708H599.824L679.798 493.599H724.241Z",
    fill: "#0086FF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M724.241 505.693V518.443L724.112 518.637L669.321 573.436H656.583L724.112 505.888L724.241 505.693Z",
    fill: "#0086FF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M672.843 526.705H578.365V532.25H672.843V526.705Z",
    fill: "#407BFF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M641.333 537.792H578.365V543.337H641.333V537.792Z",
    fill: "#407BFF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M641.333 532.247H578.365V537.792H641.333V532.247Z",
    fill: "#0086FF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M312.201 40.3516H102.352V301.613H312.201V40.3516Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M310.17 42.3798V299.582H104.38V42.3798H310.17ZM314.229 38.3203H100.321V303.641H314.229V38.3203Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M310.17 42.3799H104.406V61.8201H310.17V42.3799Z",
    fill: "#C0E7FF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M173.509 177.504H128.912V222.109H173.509V177.504Z",
    fill: "#0086FF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M173.506 177.504V222.11H128.909V177.504H173.506ZM174.411 176.599H128.006V223.012H174.411V176.599Z",
    fill: "#407BFF"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M152.644 226.303H129.963V230.408H152.644V226.303Z",
    fill: "#407BFF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M167.065 234.616H129.963V236.87H167.065V234.616Z",
    fill: "#0086FF"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M167.065 240.198H129.963V242.452H167.065V240.198Z",
    fill: "#0086FF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M167.065 245.78H129.963V248.034H167.065V245.78Z",
    fill: "#0086FF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M231.156 177.504H186.559V222.109H231.156V177.504Z",
    fill: "#0086FF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M231.153 177.504V222.11H186.559V177.504H231.153ZM232.058 176.599H185.653V223.012H232.058V176.599Z",
    fill: "#407BFF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M210.322 226.303H187.641V230.408H210.322V226.303Z",
    fill: "#407BFF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M224.743 234.616H187.641V236.87H224.743V234.616Z",
    fill: "#0086FF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M224.743 240.198H187.641V242.452H224.743V240.198Z",
    fill: "#0086FF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M224.743 245.78H187.641V248.034H224.743V245.78Z",
    fill: "#0086FF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M288.803 177.504H244.206V222.109H288.803V177.504Z",
    fill: "#0086FF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M288.803 177.504V222.11H244.206V177.504H288.803ZM289.708 176.599H243.303V223.012H289.708V176.599Z",
    fill: "#407BFF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M268.004 226.303H245.323V230.408H268.004V226.303Z",
    fill: "#407BFF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M282.425 234.616H245.323V236.87H282.425V234.616Z",
    fill: "#0086FF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M282.425 240.198H245.323V242.452H282.425V240.198Z",
    fill: "#0086FF"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M282.425 245.78H245.323V248.034H282.425V245.78Z",
    fill: "#0086FF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M167.065 251.362H129.963V253.616H167.065V251.362Z",
    fill: "#0086FF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M167.065 256.941H129.963V259.195H167.065V256.941Z",
    fill: "#0086FF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M224.743 251.362H187.641V253.616H224.743V251.362Z",
    fill: "#0086FF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M224.743 256.941H187.641V259.195H224.743V256.941Z",
    fill: "#0086FF"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M282.425 251.362H245.323V253.616H282.425V251.362Z",
    fill: "#0086FF"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M282.425 256.941H245.323V259.195H282.425V256.941Z",
    fill: "#0086FF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M310.396 267.332H104.38V299.582H310.396V267.332Z",
    fill: "#C0E7FF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M130.466 85.3711H113.4V99.7463H130.466V85.3711Z",
    fill: "#407BFF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M237.268 85.3711H132.454V99.7463H237.268V85.3711Z",
    fill: "#415065"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M261.263 85.3711H240.07V99.7463H261.263V85.3711Z",
    fill: "#C0E7FF"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M278.312 85.3711H263.939V99.7463H278.312V85.3711Z",
    fill: "#C0E7FF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M301.941 85.3711H280.982V99.7463H301.941V85.3711Z",
    fill: "#C0E7FF"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M130.466 101.926H113.4V116.301H130.466V101.926Z",
    fill: "#407BFF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M237.268 101.926H132.454V116.301H237.268V101.926Z",
    fill: "#415065"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M261.263 101.926H240.07V116.301H261.263V101.926Z",
    fill: "#C0E7FF"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M278.312 101.926H263.939V116.301H278.312V101.926Z",
    fill: "#C0E7FF"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M301.941 101.926H280.982V116.301H301.941V101.926Z",
    fill: "#C0E7FF"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M130.466 118.483H113.4V132.859H130.466V118.483Z",
    fill: "#407BFF"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M237.268 118.483H132.454V132.859H237.268V118.483Z",
    fill: "#415065"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M261.263 118.483H240.07V132.859H261.263V118.483Z",
    fill: "#C0E7FF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M278.312 118.483H263.939V132.859H278.312V118.483Z",
    fill: "#C0E7FF"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M301.941 118.483H280.982V132.859H301.941V118.483Z",
    fill: "#C0E7FF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M130.466 135.038H113.4V149.413H130.466V135.038Z",
    fill: "#407BFF"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M237.268 135.038H132.454V149.413H237.268V135.038Z",
    fill: "#415065"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M261.263 135.038H240.07V149.413H261.263V135.038Z",
    fill: "#C0E7FF"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M278.312 135.038H263.939V149.413H278.312V135.038Z",
    fill: "#C0E7FF"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M301.941 135.038H280.982V149.413H301.941V135.038Z",
    fill: "#C0E7FF"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M130.466 151.597H113.4V165.972H130.466V151.597Z",
    fill: "#407BFF"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M237.268 151.597H132.454V165.972H237.268V151.597Z",
    fill: "#415065"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M261.263 151.597H240.07V165.972H261.263V151.597Z",
    fill: "#C0E7FF"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M278.312 151.597H263.939V165.972H278.312V151.597Z",
    fill: "#C0E7FF"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M301.941 151.597H280.982V165.972H301.941V151.597Z",
    fill: "#C0E7FF"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.1 384.104H1000.7V388.632H1002.1V384.104Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.47 384.104H1004.07V388.632H1005.47V384.104Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M904.031 28.5102C904.031 28.6788 904.031 28.8473 904.036 29.0159C904.291 38.4946 912.211 45.9764 921.691 45.9764H973.385C980.232 45.0994 985.413 38.9117 984.984 31.7269C984.57 24.7765 978.843 19.2144 971.889 19.0058C969.504 18.9344 967.25 19.48 965.279 20.4942C964.154 9.42998 954.811 0.796875 943.452 0.796875C935.949 0.796875 929.328 4.56207 925.372 10.307C924.418 10.1527 923.442 10.0785 922.442 10.0785C912.274 10.0785 904.031 18.3402 904.031 28.5102Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0966797 156.721C0.0966797 156.89 0.0966798 157.058 0.102392 157.227C0.356595 166.706 8.27687 174.187 17.7566 174.187H69.4512C76.2976 173.31 81.4787 167.123 81.0503 159.938C80.6362 152.987 74.9094 147.425 67.9546 147.217C65.5696 147.145 63.3161 147.691 61.3453 148.705C60.2199 137.641 50.8773 129.008 39.5181 129.008C32.0148 129.008 25.3942 132.773 21.4383 138.518C20.4843 138.364 19.5075 138.289 18.5078 138.289C8.33971 138.289 0.0966797 146.551 0.0966797 156.721Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M800.227 802.793C800.227 802.962 800.227 803.131 800.233 803.299C800.487 812.778 808.408 820.26 817.887 820.26H869.582C876.428 819.383 881.609 813.195 881.181 806.01C880.767 799.06 875.04 793.498 868.085 793.289C865.7 793.218 863.447 793.763 861.476 794.777C860.351 783.713 851.008 775.08 839.649 775.08C832.146 775.08 825.525 778.845 821.569 784.59C820.615 784.436 819.638 784.362 818.639 784.362C808.47 784.362 800.227 792.623 800.227 802.793Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrototyping);
export default __webpack_public_path__ + "static/media/Prototyping.aeb89e8f1239d27e16323b6cefddec91.svg";
export { ForwardRef as ReactComponent };